module.exports = __webpack_public_path__ + "static/img/aboutUs.6e70f09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/aboutUs.png
// module id = Bs/t
// module chunks = 11